package com.nonopn.skywatcher.common.app.pages.profile

import androidx.compose.ui.graphics.ImageBitmap
import com.nonopn.skywatcher.common.app.api.impl.ApiLightUser
import qrcode.QRCode

data class ProfileContentModelState(
    val isSystemDarkMode: Boolean,
    val isLoading: Boolean,
    val errorLoading: Boolean = false,
    val profile: ApiLightUser? = null,
    val qrCode: QRCode? = null,
    val qrCodeImage: ImageBitmap? = null,
)
